<div class="nav-actions ms-auto">
  <div class="dropdown pc-h-item" ngbDropdown>
    <button
      type="button"
      class="pc-head-link head-link-secondary dropdown-toggle arrow-none"
      ngbDropdownToggle
      aria-label="Notificaciones"
      title="Notificaciones"
    >
      <i class="ti ti-bell" aria-hidden="true"></i>
    </button>

    <div
      class="dropdown-menu dropdown-notification dropdown-menu-end pc-h-dropdown"
      ngbDropdownMenu
    >
      <div class="dropdown-header">
        <span class="dropdown-title">Notificaciones</span>
      </div>
      <div class="notification-empty" role="status">
        <span class="notification-empty__icon" aria-hidden="true">
          <i class="ti ti-bell-check"></i>
        </span>
        <strong>Todo está al día</strong>
        <span>No tienes notificaciones nuevas.</span>
      </div>
    </div>
  </div>

  <div class="dropdown pc-h-item header-user-profile" ngbDropdown>
    <button
      type="button"
      class="pc-head-link head-link-primary dropdown-toggle arrow-none"
      ngbDropdownToggle
      aria-label="Abrir menú de usuario"
      title="Menú de usuario"
    >
      <span class="profile-avatar" aria-hidden="true"
        ><i class="ti ti-user"></i
      ></span>
      <span class="profile-copy">
        <strong>{{ currentUser?.usuarioNombre || "Usuario" }}</strong>
        <small>{{ currentUser?.rolNombre || "Cuenta activa" }}</small>
      </span>
      <i class="ti ti-chevron-down profile-chevron" aria-hidden="true"></i>
    </button>

    <div
      class="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown"
      ngbDropdownMenu
    >
      <div class="profile-summary">
        <span class="profile-avatar" aria-hidden="true"
          ><i class="ti ti-user"></i
        ></span>
        <div>
          <strong>{{ currentUser?.usuarioNombre || "Usuario" }}</strong>
          <span>{{ currentUser?.rolNombre || "Cuenta activa" }}</span>
        </div>
      </div>

      <div class="dropdown-divider"></div>

      <a [routerLink]="['/dashboard']" class="dropdown-item">
        <i class="ti ti-layout-dashboard" aria-hidden="true"></i>
        <span>Panel principal</span>
      </a>
      <button
        type="button"
        (click)="onLogout()"
        class="dropdown-item dropdown-item-danger"
      >
        <i class="ti ti-logout" aria-hidden="true"></i>
        <span>Cerrar sesión</span>
      </button>
    </div>
  </div>
</div>
